import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

const initialState = {
  reports: { content: [] },
  page: 0,
  total: 0,
  size: 10,
  loading: true,
  loadingError: null,
}

export const fetchReportsCustom = createAxiosThunk(
  'reportList/fetchReports',
  (domain, { getState }) => {
    const { page, size } = getState().report.reportList
    const param = { page, limit: size }
    if (domain !== 'ALL') {
      param.domain = domain
    }
    return api.report.getReportsCustom(param)
  }
)

export const deleteReport = createAxiosThunk('reportList/deleteReport', param =>
  api.report.deleteReport(param.id)
)

const reportListSlice = createSlice({
  name: 'reportList',
  initialState,

  reducers: {
    reset: () => initialState,
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setSize: (state, { payload: size }) => {
      state.size = size
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchReportsCustom.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchReportsCustom.fulfilled, (state, { payload }) => {
      state.loading = false
      state.reports = payload.customReports
      state.total = payload.customReports.totalElements
      state.numberOfElements = payload.customReports.numberOfElements
    })

    builder.addCase(fetchReportsCustom.rejected, (state, action) => {
      state.loading = false
      state.loadingError = action.payload || true
    })

    builder.addCase(deleteReport.pending, state => {
      state.loading = true
    })

    builder.addCase(deleteReport.fulfilled, state => {
      state.loading = false
    })

    builder.addCase(deleteReport.rejected, (state, action) => {
      state.loading = false
      state.loadingError = action.payload || true
    })
  },
})

export const { setPage, setSize, reset } = reportListSlice.actions
export default reportListSlice.reducer
